module.exports = __webpack_public_path__ + "img/side_dish_audio.ef484ffe.jpg";